import React from 'react';

interface ApplicationCategoryProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    isSelected: boolean;
    onSelect: () => void;
}

const ApplicationCategory = ({ icon, title, description, isSelected, onSelect }: ApplicationCategoryProps) => {
    return (
        <div
            className={`rounded-lg relative bg-white  p-6 cursor-pointer transition-all duration-200 ${isSelected
                ? 'ring-2 ring-primary'
                : 'bg-white '
                }`}
            onClick={onSelect}
        >
            {isSelected && <span className="absolute top-3 left-3  h-4 w-4 rounded-full bg-primary ring-2 ring-primary-400 p-1"></span>}
            {!isSelected && <div className='absolute top-3 left-3  h-4 w-4 rounded-full bg-white ring-2 ring-gray-200 p-1'></div>}
            <div className="flex items-center justify-center mb-4">{icon}</div>
            <h3 className="text-lg font-semibold mb-1">{title}</h3>
            <p className="text-gray-600 text-sm font-light">{description}</p>
        </div>
    );
};

export default ApplicationCategory;